import React, {useState, useEffect, useRef, useMemo} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputText from '../FormFields/InputText';
import SelectInfinite from '../FormFields/SelectInfinite';
import TextArea from '../FormFields/Textarea';
import InputDate from '../FormFields/inputDate/InputDate';
import {getLanguage, t} from 'react-switch-lang';
import * as yup from 'yup';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {addMeasure} from '../../services/measuresService/measuresApi';
import {getAllRiskRelatedUsers} from '../../services/usersService';
import {format} from 'date-fns';
import Toast from '../toast/Toast';
import {appModules, defaultMinValueZero, validDouble} from '../../utils/const';
import PreventTransitionPrompt from '../preventTransitionprompt/PreventTransition';
import SelectList from '../../components/FormFields/select/SelectList';
import {Spin} from 'antd';
import FileUploadSection from "../FileUploadSection/FileUploadSection";
import {
    formatNumberInput,
    parseFormattedNumber,
    maxDecimalNumber, formatNumberForDisplay,
    onDecimalNumberInputChange, testIsGreaterThanMin,
    testValidNumber, handlePasteAndValidate
} from "../../utils/helpers";

function MeasuresFromAdd({
                             userData,
                             toggleOpen,
                             departmentData,
                             open,
                             id,
                             tab,
                             estimatedGrossLost,
                         }) {
    const [users, setUsers] = useState();
    const [loading, setLoading] = useState(true);
    const [disableBtn, setDisableBtn] = useState(false);
    const [files, setFiles] = useState([]);
    const [isAdding, setIsAdding] = useState(true);
    const [transitionModal, setTransitionModal] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [hasMore, setHasMore] = useState(true);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const fetchUsers = async (pageNumber = 0, ) => {
    try {
      const { data } = await getAllRiskRelatedUsers(pageNumber, pageSize);
      const content = Array.isArray(data?.content) ? data.content : [];

      const usersMap = content.map((item) => ({
        value: item.id,
        label: `${item.firstName} ${item.lastName}`,
      }));

      if (pageNumber === 0) {
        setUsers(usersMap);
      } else {
        setUsers((prev) => [...prev, ...usersMap]);
      }

      setPage(pageNumber);
      setHasMore(!data.last);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchUsers(0);
  }, []);
  const handleLoadMoreUsers = () => {
    if (!hasMore || loadingUsers) return;
    const nextPage = page + 1;
    fetchUsers(nextPage);
  };
    const [schema, setScheme] = useState(
        yup.object().shape({
            realizationDate: yup
                .string()
                .nullable()
                .trim()
                .required(t('message.fieldRequired')),
            riskAnalysis: yup
                .string()
                .trim()
                .max(2000, t('message.max', {max: 2000})),
            levelOfMeasureRealization: yup
                .object()
                .nullable()
                .required(t('message.fieldRequired')),
            cost: yup.object().nullable().required(t('message.fieldRequired')),
            department: yup.object().nullable().required(t('message.fieldRequired')),
            grossLoss: yup
                .string()
                .trim()
              .when([], {
                is: () => !window.location.pathname.includes('potential-risk'),
                then: (schema) =>
                  schema
                    .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                      return testIsGreaterThanMin(value, defaultMinValueZero);
                    })
                    .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                      return testValidNumber(value, true);
                    })
                    .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                      return maxDecimalNumber(value);
                    }),
                otherwise: yup.string().trim(),
              })
                .typeError(t('message.onlyDecimalNumbers')),
            lossChargedInsurance: yup
                .string()
                .trim()
              .when([], {
                is: () => !window.location.pathname.includes('potential-risk'),
                then: (schema) =>
                  schema
                    .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                      return testIsGreaterThanMin(value, defaultMinValueZero);
                    })
                    .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                      return testValidNumber(value, true);
                    })
                    .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                      return maxDecimalNumber(value);
                    }),
                otherwise: yup.string().trim(),
              })
                .typeError(t('message.onlyDecimalNumbers')),
            lossChargedOther: yup
                .string()
                .trim()
              .when([], {
                is: () => !window.location.pathname.includes('potential-risk'),
                then: (schema) =>
                  schema
                    .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                      return testIsGreaterThanMin(value, defaultMinValueZero);
                    })
                    .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                      return testValidNumber(value, true);
                    })
                    .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                      return maxDecimalNumber(value);
                    }),
                otherwise: yup.string().trim(),
              })
                // .matches(validDouble, t('message.onlyDecimalNumbers'))
                .typeError(t('message.onlyDecimalNumbers')),
            netLoss: yup
                .string()
                .trim()
              .when([], {
                is: () => !window.location.pathname.includes('potential-risk'),
                then: (schema) =>
                  schema
                    .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                      return testIsGreaterThanMin(value, defaultMinValueZero);
                    })
                    .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                      return testValidNumber(value, true);
                    })
                    .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                      return maxDecimalNumber(value);
                    }),
                otherwise: yup.string().trim(),
              })
                .typeError(t('message.onlyDecimalNumbers')),
            hdRequestId: yup
                .string()
                .trim(),
            mitigationPercentage: yup
                .string()
                .trim()
                .matches(validDouble, t('message.onlyDecimalNumbers'))
                .typeError(t('message.onlyDecimalNumbers'))
                .test('max-100', t('message.maxValue', { max: 100 }), value => {
                    const num = parseFloat(value?.replace(',', '.') ?? '');
                    return isNaN(num) || num <= 100;
                }),
            mitigationMeasures: yup
                .string()
                .trim()
                .required(t('message.fieldRequired'))
                .max(2000, t('message.max', {max: 2000})),
            notStartedReason: yup
                .string()
                .trim()
                .max(1000, t('message.max', {max: 1000})),
            resultOfApplied: yup
                .string()
                .trim()
                .max(1000, t('message.max', {max: 1000})),
        })
    );

    const l = getLanguage();

    const optionsTask = [
        {value: 'NOTSTARTED', label: `${t('mitigation-measures.notStarted')}`},
        {value: 'INPROGRESS', label: `${t('mitigation-measures.inProgress')}`},
        {value: 'REALIZED', label: `${t('mitigation-measures.realized')}`},
    ];

    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const {handleSubmit, watch, setValue,setError,clearErrors,trigger} = methods;
    const wathcLevelOfRealization = watch('levelOfMeasureRealization');

    const submitForm = async (submitedData) => {
        setDisableBtn(true);
        const files = document.getElementById('upload').files;
        const date =
            format(new Date(submitedData.realizationDate), 'yyyy-MM-dd') +
            'T' +
            format(new Date(submitedData.realizationDate), 'hh:mm:ss');
        const payload = {
            mitigationMeasures: submitedData.mitigationMeasures,
            costEstimationId: submitedData.cost.value,
            departmentInChargeId: submitedData.department.value,
            grossLoss: parseFormattedNumber(watch('grossLoss')),
            lossChargedInsurance: parseFormattedNumber(submitedData.lossChargedInsurance),
            lossChargedOther: parseFormattedNumber(submitedData.lossChargedOther),
            mitigationPercentage: parseFloat(submitedData.mitigationPercentage),
            hdRequestId: submitedData.hdRequestId,
            netLoss: parseFormattedNumber(watch('netLoss')),
            riskAnalysis: submitedData.riskAnalysis,
            realizationDate: date,
            notStartedReason: submitedData.notStartedReason,
            levelOfMeasureRealization: submitedData.levelOfMeasureRealization.value,
            userResponsibleId: submitedData.userResponsibleId.value,
            riskId: id,
            userCreatedId: userData.id,
            additionalMitigationMeasures: submitedData.additionalMitigationMeasures,
            appliedMeasureResult: {name: submitedData.resultOfApplied},
        };
        try {
            const response = await addMeasure(payload, files);
            if (response.status === 201) {
                await Toast.fire({
                    title: t('message.addSuccess3', {entity: t('common.measure')}),
                    icon: 'success',
                });
                setIsAdding(false);
            }
            await window.location.reload();
            setDisableBtn(false);
        } catch (err) {
            if (err.response.data.errorKey === 'notInProgress') {
                await Toast.fire({
                    title: t('message.riskNotInprogress'),
                    icon: 'error',
                });
            }
            if (err.response.code === 'file-format') {
                await Toast.fire({
                    title: t('message.fileFormatNotAllowed'),
                    icon: 'error',
                });
            }
            if (err.response.status === 400) {
                await Toast.fire({
                    title: t('message.errorApi'),
                    icon: 'error',
                });
                setIsAdding(false);
            }
            toggleOpen(!open);
        }
    };

    useEffect(() => {
        if (wathcLevelOfRealization?.value) {
            if (wathcLevelOfRealization?.value === 'NOTSTARTED') {
                setScheme(
                    yup.object().shape({
                        realizationDate: yup
                            .string()
                            .nullable()
                            .trim()
                            .required(t('message.fieldRequired')),
                        riskAnalysis: yup
                            .string()
                            .trim()
                            .max(2000, t('message.max', {max: 2000})),
                        levelOfMeasureRealization: yup
                            .object()
                            .nullable()
                            .required(t('message.fieldRequired')),
                        cost: yup.object().nullable().required(t('message.fieldRequired')),
                        department: yup
                            .object()
                            .nullable()
                            .required(t('message.fieldRequired')),
                        notStartedReason: yup
                            .string()
                            .trim()
                            .required(t('message.fieldRequired'))
                            .max(1000, t('message.max', {max: 1000})),
                        grossLoss: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            .typeError(t('message.onlyDecimalNumbers')),
                        lossChargedInsurance: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            // .matches(validDouble, t('message.onlyDecimalNumbers'))
                            .typeError(t('message.onlyDecimalNumbers')),
                        lossChargedOther: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            // .matches(validDouble, t('message.onlyDecimalNumbers'))
                            .typeError(t('message.onlyDecimalNumbers')),
                        netLoss: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            .typeError(t('message.onlyDecimalNumbers')),
                        mitigationMeasures: yup
                            .string()
                            .trim()
                            .required(t('message.fieldRequired'))
                            .max(2000, t('message.max', {max: 2000})),
                        hdRequestId: yup
                            .string()
                            .trim(),
                        mitigationPercentage: yup
                            .string()
                            .trim()
                            .matches(validDouble, t('message.onlyDecimalNumbers'))
                            .typeError(t('message.onlyDecimalNumbers'))
                            .test('max-100', t('message.maxValue', { max: 100 }), value => {
                                const num = parseFloat(value?.replace(',', '.') ?? '');
                                return isNaN(num) || num <= 100;
                            }),
                        resultOfApplied: yup
                            .string()
                            .trim()
                            .max(1000, t('message.max', {max: 1000})),
                    })
                );
            } else if (wathcLevelOfRealization?.value === 'INPROGRESS') {
                setScheme(
                    yup.object().shape({
                        realizationDate: yup
                            .string()
                            .nullable()
                            .trim()
                            .required(t('message.fieldRequired')),
                        riskAnalysis: yup
                            .string()
                            .trim()
                            .max(2000, t('message.max', {max: 2000})),
                        levelOfMeasureRealization: yup
                            .object()
                            .nullable()
                            .required(t('message.fieldRequired')),
                        cost: yup.object().nullable().required(t('message.fieldRequired')),
                        department: yup
                            .object()
                            .nullable()
                            .required(t('message.fieldRequired')),
                        resultOfApplied: yup
                            .string()
                            .trim()
                            .required(t('message.fieldRequired'))
                            .max(1000, t('message.max', {max: 1000})),
                        grossLoss: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            // .matches(validDouble, t('message.onlyDecimalNumbers'))
                            .typeError(t('message.onlyDecimalNumbers')),
                        lossChargedInsurance: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            // .matches(validDouble, t('message.onlyDecimalNumbers'))
                            .typeError(t('message.onlyDecimalNumbers')),
                        lossChargedOther: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            // .matches(validDouble, t('message.onlyDecimalNumbers'))
                            .typeError(t('message.onlyDecimalNumbers')),
                        netLoss: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            .typeError(t('message.onlyDecimalNumbers')),
                        mitigationMeasures: yup
                            .string()
                            .trim()
                            .required(t('message.fieldRequired'))
                            .max(2000, t('message.max', {max: 2000})),
                        notStartedReason: yup
                            .string()
                            .trim()
                            .max(1000, t('message.max', {max: 1000})),
                        hdRequestId: yup
                            .string()
                            .trim(),
                        mitigationPercentage: yup
                            .string()
                            .trim()
                            .matches(validDouble, t('message.onlyDecimalNumbers'))
                            .typeError(t('message.onlyDecimalNumbers'))
                            .test('max-100', t('message.maxValue', { max: 100 }), value => {
                                const num = parseFloat(value?.replace(',', '.') ?? '');
                                return isNaN(num) || num <= 100;
                            }),
                    })
                );
            } else {
                setScheme(
                    yup.object().shape({
                        realizationDate: yup
                            .string()
                            .nullable()
                            .trim()
                            .required(t('message.fieldRequired')),
                        riskAnalysis: yup
                            .string()
                            .trim()
                            .max(2000, t('message.max', {max: 2000})),
                        levelOfMeasureRealization: yup
                            .object()
                            .nullable()
                            .required(t('message.fieldRequired')),
                        cost: yup.object().nullable().required(t('message.fieldRequired')),
                        department: yup
                            .object()
                            .nullable()
                            .required(t('message.fieldRequired')),
                        resultOfApplied: yup
                            .string()
                            .trim()
                            .required(t('message.fieldRequired'))
                            .max(1000, t('message.max', {max: 1000})),
                        grossLoss: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            .typeError(t('message.onlyDecimalNumbers')),
                        lossChargedInsurance: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            .typeError(t('message.onlyDecimalNumbers')),
                        lossChargedOther: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            // .matches(validDouble, t('message.onlyDecimalNumbers'))
                            .typeError(t('message.onlyDecimalNumbers')),
                        netLoss: yup
                            .string()
                            .trim()
                          .when([], {
                            is: () => !window.location.pathname.includes('potential-risk'),
                            then: (schema) =>
                              schema
                                .test('is-greater-than-min', t('message.minValue', { min: defaultMinValueZero }), (value) => {
                                  return testIsGreaterThanMin(value, defaultMinValueZero);
                                })
                                .test('is-valid-number', t('message.mustBeNumber'), (value) => {
                                  return testValidNumber(value, true);
                                })
                                .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
                                  return maxDecimalNumber(value);
                                }),
                            otherwise: yup.string().trim(),
                          })
                            .typeError(t('message.onlyDecimalNumbers')),
                        mitigationMeasures: yup
                            .string()
                            .trim()
                            .required(t('message.fieldRequired'))
                            .max(2000, t('message.max', {max: 2000})),
                        hdRequestId: yup
                            .string()
                            .trim(),
                        mitigationPercentage: yup
                            .string()
                            .trim()
                            .matches(validDouble, t('message.onlyDecimalNumbers'))
                            .typeError(t('message.onlyDecimalNumbers'))
                            .test('max-100', t('message.maxValue', { max: 100 }), value => {
                                const num = parseFloat(value?.replace(',', '.') ?? '');
                                return isNaN(num) || num <= 100;
                            }),

                        // additionalMitigationMeasures: yup.string().trim(),
                        // .max(2000, t('message.max', {max: 2000})),
                        notStartedReason: yup
                            .string()
                            .trim()
                            .max(1000, t('message.max', {max: 1000})),
                    })
                );
            }
        }
    }, [wathcLevelOfRealization]);

    const grossLossFormatted = useMemo(() => {
        if(estimatedGrossLost !== null && estimatedGrossLost !== 'no-data') {
            return formatNumberInput(formatNumberForDisplay(estimatedGrossLost));
        }else {
            return '';
        }
    }, [estimatedGrossLost]);


  const onChangeLossChargedInsurance = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('lossChargedInsurance', result);
  };

  const onChangeLossChargedOther = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('lossChargedOther', result);
  };

    const onChangeMitigationPercentage = (e) => {
        let result = '';
        let valueNoText = e.target.value.replace(/[^0-9.]/, '');
        let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
        if (valueDouble !== undefined && valueDouble !== null) {
            result = valueDouble[1];
        }
            setValue('mitigationPercentage', result);
    };

    const watchLossChargedInsurance = watch('lossChargedInsurance');
    const watchLossChargedOther = watch('lossChargedOther');
    const watchEstimatedGrossLost = watch('grossLoss');

    const setNetLossValue = (num) => {
        if(num < 0) {
            setError("netLoss", { type: 'is-greater-than-min', message: t('message.minValue', {min: defaultMinValueZero})})
        }else {
            clearErrors('netLoss')
        }
        if(num) {
            setValue(
                'netLoss',
                formatNumberInput(
                    formatNumberForDisplay(num).includes(',')
                        ? formatNumberForDisplay(num)
                        : formatNumberForDisplay(num) + ',00'
                    , 2
                )
            );
        } else {
            setValue('netLoss',0)
        }
    }

    useEffect(() => {
        if (watchLossChargedInsurance && watchLossChargedOther) {
            let no =
                parseFormattedNumber(watchEstimatedGrossLost) -
                parseFormattedNumber(watchLossChargedInsurance) -
                parseFormattedNumber(watchLossChargedOther);
                setNetLossValue(no)
        }
    }, [watchLossChargedInsurance, watchEstimatedGrossLost, watchLossChargedOther]);


    return (
        <>
            {loading ? (
                <Spin spinning={loading} size={'large'} className="spinner"/>
            ) : (
                <>
                    {/* <TransitionModal open={}/> */}
                    <PreventTransitionPrompt when={isAdding}/>
                    <FormProvider {...methods}>
                        <form onSubmit={handleSubmit(submitForm)}>
                            <Row className="mb-5 main-form">
                                <Col xs={6} md={6} lg={3}>
                                    <label className="label-measures">
                                        {t('mitigation-measures.person')}
                                    </label>
                                    <SelectList
                                        name="userResponsibleId"
                                        className="select"
                                        options={users}
                                        defaultValue={{
                                            value: userData.id,
                                            label: userData.firstName + ' ' + userData.lastName,
                                        }}
                                        placeholder={t('placeholder.userResponsibleId')}
                                        isClearable={false}
                                        onMenuScrollToBottom={handleLoadMoreUsers}
                                        isLoading={loadingUsers}
                                    />
                                    <label className="label-measures">
                                        {t('mitigation-measures.analysis')}
                                    </label>
                                  <span className="optional register">{t('common.optional')}</span>
                                    <TextArea
                                        name="riskAnalysis"
                                        className={`form-control height text-area `}
                                        placeholder={t('placeholder.riskAnalysis')}
                                    />
                                </Col>
                                <Col xs={6} md={6} lg={3}>
                                    <label className="label-measures">
                                        {t('mitigation-measures.proposed')}
                                    </label>
                                    <TextArea
                                        name="mitigationMeasures"
                                        className={`form-control text-area `}
                                        placeholder={t('placeholder.mitigationMeasures')}
                                    />
                                    <label className="label-measures">
                                        {t('mitigation-measures.charge-of-implementing')}
                                    </label>
                                    <SelectInfinite
                                        name="department"
                                        api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                                        labelKey={l === 'mne' ? 'name' : 'nameEn'}
                                        className="select"
                                        placeholder={t('placeholder.departments')}
                                        isClearable={false}
                                    />
                                    <label className="label-measures">
                                        {t('mitigation-measures.cost-estimation')}
                                    </label>
                                    <SelectInfinite
                                        api="/cost-estimations"
                                        name="cost"
                                        labelKey="cost"
                                        className="select"
                                        placeholder={t('placeholder.costEstimation')}
                                        queryKeys={'cost.contains'}
                                    />
                                    <label className="label-measures">
                                        {t('mitigation-measures.date')}
                                    </label>
                                    <InputDate
                                        name="realizationDate"
                                        placeholderText={t('placeholder.pickDate')}
                                        minDate={new Date()}
                                        isClearable={true}
                                    />
                                </Col>
                                <Col xs={6} md={6} lg={3}>
                                    <label className="label-measures">
                                        {t('mitigation-measures.result')}
                                    </label>
                                    <TextArea
                                        name="resultOfApplied"
                                        className={`form-control height text-area `}
                                        placeholder={t('placeholder.result')}
                                    />
                                    <label className='label-measures'>
                                        {t('mitigation-measures.IDHDRequest')}
                                    </label>
                                    <span className="optional register">
                    {t('common.optional')}
                  </span>
                                    <InputText
                                        type='string'
                                        name='hdRequestId'
                                        className='form-control input-field'
                                        placeholder={t('placeholder.IDHDRequest')}
                                        id='hdRequestId'
                                    />
                                    <label className="label-measures">
                                        {t('mitigation-measures.mitigation-percentage')}
                                    </label>
                                    <span className="optional register">
                    {t('common.optional')}
                  </span>
                                    <InputText
                                        type="number"
                                        name="mitigationPercentage"
                                        className="form-control input-field"
                                        placeholder={t('placeholder.mitigationPercentage')}
                                        step=".01"
                                        min="0"
                                        onChange={onChangeMitigationPercentage}
                                    />
                                    <label className="label-measures">
                                        {t('mitigation-measures.status')}
                                    </label>
                                    <SelectList
                                        name="levelOfMeasureRealization"
                                        className="select"
                                        options={optionsTask}
                                        placeholder={t('placeholder.levelOfMeasureRealization')}
                                        isClearable={false}
                                    />
                                </Col>
                                {/* {wathcLevelOfRealization?.value === 'NOTSTARTED' && ( */}
                                <Col xs={6} md={6} lg={3}>
                                    <label className="label-measures">
                                        {t('mitigation-measures.reason')}
                                    </label>
                                    <TextArea
                                        name="notStartedReason"
                                        className={`form-control text-area `}
                                        placeholder={t('placeholder.notStartedReason')}
                                    />
                                </Col>
                                {/* )} */}
                              {!window.location.pathname.includes('potential-risk') &&
                                <Col xs={6} md={6} lg={3}>
                                    <label className="label-measures">
                                        {t('mitigation-measures.loss-gross')}
                                    </label>
                                    <span className="optional register">
                    {t('common.optional')}
                  </span>
                                    <InputText
                                        type="text"
                                        name="grossLoss"
                                        className="form-control input-field"
                                        placeholder={t('placeholder.lossGross')}
                                        onChange={(e) => onDecimalNumberInputChange(e, setValue, "grossLoss")}
                                        onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'grossLoss')}
                                        defaultValue={grossLossFormatted}
                                    />
                                    <label className="label-measures">
                                        {t('mitigation-measures.loss-collected')}
                                    </label>
                                    <span className="optional register">
                    {t('common.optional')}
                  </span>
                                    <InputText
                                        type="text"
                                        name="lossChargedInsurance"
                                        className="form-control input-field"
                                        placeholder={t('placeholder.lossCollected')}
                                        onChange={(e) => onDecimalNumberInputChange(e, setValue, "lossChargedInsurance")}
                                        onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'lossChargedInsurance')}
                                    />
                                    <label className="label-measures">
                                        {t('mitigation-measures.loss-collected-other')}
                                    </label>
                                    <span className="optional register">
                    {t('common.optional')}
                  </span>
                                    <InputText
                                        type="text"
                                        name="lossChargedOther"
                                        className="form-control input-field"
                                        placeholder={t('placeholder.lossCollectedOther')}
                                        onChange={(e) => onDecimalNumberInputChange(e, setValue, "lossChargedOther")}
                                        onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'lossChargedOther')}
                                    />
                                    <label className="label-measures">
                                        {t('mitigation-measures.loss-net')}
                                    </label>
                                    <span className="optional register">
                    {t('common.optional')}
                  </span>
                                    <InputText
                                        type="text"
                                        name="netLoss"
                                        className="form-control input-field"
                                        placeholder={t('placeholder.lossNet')}
                                        onChange={(e) => onDecimalNumberInputChange(e, setValue, "netLoss")}
                                        // defaultValue={estimatedGrossLost !== null && estimatedGrossLost !== 'no-data' ? formatNumberInput(formatNumberForDisplay(estimatedGrossLost)) : ''}
                                        disabled={true}
                                    />
                                </Col>}
                                <Col xs={6} md={6} lg={3}>
                                    <label className="label-measures">
                                        {t('mitigation-measures.proposalAdditional')}
                                    </label>
                                    <span className="optional register">
                    {t('common.optional')}
                  </span>
                  <InputText
                    type="text"
                    name="additionalMitigationMeasures"
                    className="form-control input-field"
                    placeholder={t('placeholder.mitigationMeasuresAdditional')}
                  />
                  <label className="label-measures">
                    {t('mitigation-measures.upload')}
                  </label>
                  <FileUploadSection disabled={false} />
                </Col>
              </Row>
              <Row className="mb-3 pt-3 right-btns">
                <Col lg={12} className="btns-float-right">
                  <button
                    className="btn btn-cancel btn-strong"
                    type="reset"
                    onClick={toggleOpen}
                  >
                    {t('buttons.cancelBtn')}
                  </button>
                  <button
                    className="btn btn-primary btn-strong"
                    disabled={disableBtn}
                  >
                    {t('buttons.saveBtn')}
                  </button>
                </Col>
              </Row>
            </form>
          </FormProvider>
        </>
      )}
    </>
  );
}

export default MeasuresFromAdd;
